/**
 * Utility to detect the safari browser on desktop/iOS.
 *
 * @returns A boolean value.
 *
 * Safari detection from: http://jsfiddle.net/jlubean/dL5cLjxt/
 */
export const browserIsSafari = () => {
    const safari = !!navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    return safari || iOS ? true : false;
};
/**
 * Utility to detect iOS.
 *
 * @returns A boolean value.
 *
 * iOS detection from: http://stackoverflow.com/a/9039885/177710
 */
export const isIosDevice = () => {
    return (typeof navigator !== 'undefined' &&
        (navigator.userAgent.match(/(iPod|iPhone|iPad)/g) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
        !window.MSStream);
};
//# sourceMappingURL=browser-detection.js.map